export default {
    getPlayerImg: function(teamId, playerId, seasonId = 'current') {
        return this._getCDNPlayerUrl(teamId, playerId, 88, 88, 'png', seasonId);
    },
    getPlayerImgBig: function(teamId, playerId, seasonId = 'current') {
        return this._getCDNPlayerUrl(teamId, playerId, 524, 584, 'png', seasonId);
    },
    getPlayerImgOriginal: function(teamId, playerId, seasonId = 'current') {
        return this._getCDNPlayerUrl(teamId, playerId, null, null, 'png', seasonId);
    },
    getPlayerLargeImg: function(teamId, playerId, seasonId = 'current') {
        return this._getCDNPlayerUrl(teamId, playerId, 262, 292, 'png', seasonId);
    },
    getTeamImg: function(teamId, seasonId) {
        seasonId = 11488;
        return this._getCDNTeamUrl(teamId, 262, 262, 'png', seasonId);
    },
    getTeamLargeImg: function(teamId, seasonId) {
        seasonId = 11488;
        return this._getCDNTeamUrl(teamId, 262, 262, 'png', seasonId);
    },
    getFlagImg: function(countryId, width = 17, height = 10) {
        return `https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_flage_${countryId}.png&width-px=${width}&height-px=${height}`;
    },
    _getCDNPlayerUrl: function(teamId, playerId, width, height, format, seasonId) {
        var size = 'original';
        if (width && height) size = width + 'x' + height;
        return (
            'https://driu3sl4x7vty.cloudfront.net/wdp/' +
            seasonId +
            '/' +
            size +
            '/' +
            teamId +
            '/' +
            playerId +
            '.' +
            format
        );
    },
    _getCDNTeamUrl: function(teamId, width, height, format, seasonId) {
        return (
            'https://dxugi372p6nmc.cloudfront.net/spdk/' +
            seasonId +
            '/' +
            width +
            'x' +
            height +
            '/' +
            teamId +
            '/teamlogo.' +
            format
        );
    },
    _getS3Url: function(teamId, playerId, width, height, format, seasonId) {
        return (
            'https://s3-eu-west-1.amazonaws.com/sport.images/spdk/' +
            seasonId +
            '/' +
            width +
            'x' +
            height +
            '/' +
            teamId +
            '/' +
            playerId +
            '.' +
            format
        );
    },
    getMatchPageHeaderImage: function(teamId, tournamentId, matchGallery, seasonId) {
        seasonId = 10392;
        if (tournamentId === 85 || tournamentId === 239) {
            return matchGallery
                ? this.urls.assets('images/spdk/1-2-divisions/match_gallery_small.jpg')
                : this.urls.assets('images/spdk/1-2-divisions/match_header.jpg');
        }
        return (
            'https://d2r4jv2ozk6vji.cloudfront.net/spdk/' + seasonId + '/1920x500/' + teamId + '/home_match_image.jpg'
        );
    },
    getLiveStatsBackgroundImage: function(teamId, seasonId) {
        return (
            'https://dx7x1cuv1qubz.cloudfront.net/spdk/' +
            seasonId +
            '/1920x500/' +
            teamId +
            '/live_stats_center_background.jpg'
        );
    },
    getHead2HeadImage: function(teamId, seasonId) {
        return (
            'https://d1x64qk0gqfk0t.cloudfront.net/spdk/' + seasonId + '/1920x500/' + teamId + '/head2head_image.jpg'
        );
    },
    getTeamProfileImage: function(teamId, seasonId) {
        return 'https://s3-eu-west-1.amazonaws.com/spdk/' + seasonId + '/1920x500/' + teamId + '/team_profile.jpg';
    },
    getRandomBackground: function() {
        var n = Math.floor(Math.random() * 5) + 1;
        return 'url(' + this.urls.assets('images/spdk/backgrounds/fun_bg' + n + '.jpg') + ')';
    },
    getTeamShirtImg: function(teamId) {
        return `https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_${teamId}.png&width-px=40&height-px=40&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png`;
    }
};



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/ImageUrlHelper.js
 **/